// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".41dcfa3c3deb42a9dd1c4f2e6f8f3365.js";
};